import type { SizeChartRow } from '../types/store'

export function normalizeSizeToken(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .replace(/,/g, '.')
    .replace(/\s+/g, '')
}

const SIZE_ROW_HINTS = ['rozmiar', 'size', 'eu', 'uk', 'us']

function isSizeRow(label: string): boolean {
  const normalized = label.toLowerCase()
  return SIZE_ROW_HINTS.some(hint => normalized.includes(hint))
}

export interface SizeLookupResult {
  columnIndex: number
  sizeRowIndex: number
}

export function findSizeColumn(
  headers: string[],
  rows: SizeChartRow[],
  selectedSize: string,
): SizeLookupResult | null {
  const target = normalizeSizeToken(selectedSize)
  if (!target) return null

  for (let i = 1; i < headers.length; i++) {
    if (normalizeSizeToken(headers[i] ?? '') === target) {
      return { columnIndex: i - 1, sizeRowIndex: -1 }
    }
  }

  for (let r = 0; r < rows.length; r++) {
    const row = rows[r]
    if (!row) continue
    if (!isSizeRow(row.label)) continue
    for (let c = 0; c < row.values.length; c++) {
      if (normalizeSizeToken(row.values[c] ?? '') === target) {
        return { columnIndex: c, sizeRowIndex: r }
      }
    }
  }

  for (let r = 0; r < rows.length; r++) {
    const row = rows[r]
    if (!row) continue
    for (let c = 0; c < row.values.length; c++) {
      if (normalizeSizeToken(row.values[c] ?? '') === target) {
        return { columnIndex: c, sizeRowIndex: r }
      }
    }
  }

  return null
}

export interface MeasurementEntry {
  label: string
  value: string
}

export function collectMeasurements(
  rows: SizeChartRow[],
  lookup: SizeLookupResult,
): MeasurementEntry[] {
  const out: MeasurementEntry[] = []
  for (let r = 0; r < rows.length; r++) {
    if (r === lookup.sizeRowIndex) continue
    const row = rows[r]
    if (!row) continue
    const value = row.values[lookup.columnIndex] ?? ''
    if (!value) continue
    out.push({ label: row.label, value })
  }
  return out
}
